import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Gantt } from "@scenes/optimizedGantt";
import { Props } from "./types";
import { ProjectEdition } from "./projectEdition";
import styles from "./styles.scss";

function GanttPage({ project }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.ganttPage}>
      <Helmet>
        <title>Planzone • {t("projectPage.ganttPage.title")}</title>
        <meta name="description" content={project.description} />
      </Helmet>
      {!project.rootList.startDate || !project.rootList.endDate ? (
        <div className={styles.projectEdition}>
          <div className={styles.projectEditionOverlay} />
          <div className={styles.projectEditionMain}>
            <ProjectEdition project={project} />
          </div>
        </div>
      ) : (
        <Gantt
          projects={[project]}
          range={{
            minDate: project.rootList.startDate,
            maxDate: project.rootList.endDate,
          }}
          filter={{
            projects: [project],
            elementTypes: [
              "list",
              "task",
              "milestone",
              "event",
              "completedWork",
            ],
            scope: "project",
          }}
          sort="ascendingRank"
          namespace={project.uuid}
          isFetchingProjects={false}
          canRetrieveProjects={false}
          retrieveProjects={() => {}}
        />
      )}
    </div>
  );
}

export { GanttPage };
